export class Dashboard{
  
    /**
     *
     */
    constructor() {
            
    }
    public totalUsers:any; 
    public lastSevenDayLogins:any=[]; 
    public lastSevenDaySignUps:any=[]; 
    public applicationCount:any;
}